const url = 'whearhouse';
import { api } from 'api';
import Swal from 'sweetalert2';
import { push } from 'react-router-redux';
import { goBack } from 'react-router-redux';
import { initialize as initializeForm } from 'redux-form';
import { createActions, handleActions } from 'redux-actions';
import moment from "moment";

const LOADER_WHEARHOUSE = 'LOADER_WHEARHOUSE';
const SET_DATA_WHEARHOUSE = 'SET_DATA_WHEARHOUSE';
const SET_PAGE_WHEARHOUSE = 'SET_PAGE_WHEARHOUSE';
const SET_UPDATE_DATA_WHEARHOUSE = 'SET_UPDATE_DATA_WHEARHOUSE';
const SET_BUSCADOR_WHEARHOUSE = 'SET_BUSCADOR_WHEARHOUSE';
const SET_FILTRO_WHEARHOUSE = 'SET_FILTRO_WHEARHOUSE';

const listar = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_WHEARHOUSE, cargando: true});
    const store = getStore();
    const search = store.whearhouse.buscador;
    const filtro = store.whearhouse.filtro_whearhouse;
    let params = {page, search};
    if(filtro){
        params[''] = filtro
    }

    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_WHEARHOUSE, cargando: false});
        Swal(
            'Error',
            error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            dispatch({type: SET_DATA_WHEARHOUSE, data});
            dispatch({type: SET_PAGE_WHEARHOUSE, page});
        }
        dispatch({type: LOADER_WHEARHOUSE, cargando: false});
    })
};

const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_WHEARHOUSE, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_WHEARHOUSE, cargando: false});
        if(error.statusCode === 404){
            dispatch(push('/warehouse'))
        }
    }).then((data) => {
        dispatch({type: LOADER_WHEARHOUSE, cargando: false});
        if(data){
            const subsidiary = { value: data.subsidiary.id, label: data.subsidiary.name }
            data.subsidiary = subsidiary;
            dispatch({type: SET_UPDATE_DATA_WHEARHOUSE, updateData: data});
            dispatch(initializeForm('bodegas', data))
        }
    })
}

const create = () => (dispatch, getStore) => {
    const formData = getStore().form.bodegas.values;
    const subsidiary = formData.subsidiary.value;
    formData.subsidiary = subsidiary;

    dispatch({type: LOADER_WHEARHOUSE, cargando: true})

    api.post(`${url}`, formData).then((data) => {
        dispatch({type: LOADER_WHEARHOUSE, cargando: false})
        Swal('Éxito', 'Se ha creado la bodega.', 'success')
        .then(() => {
            dispatch(push('/warehouse'))
        })
    }).catch((error) => {
        dispatch({type: LOADER_WHEARHOUSE, cargando: false})
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).finally(() => {
        dispatch({type: LOADER_WHEARHOUSE, cargando: false})
    });
};

const update = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.bodegas.values);
    const subsidiary = formData.subsidiary.value;
    formData.subsidiary = subsidiary;

    dispatch({type: LOADER_WHEARHOUSE, cargando: true});
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_WHEARHOUSE, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                dispatch(push('/warehouse'));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_WHEARHOUSE, cargando: false});
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )
        if(error.statusCode === 404){
            dispatch(push('/warehouse/create'));
        }
    })
}

const destroy = (id) => (dispatch, getStore) => {
    dispatch({type: LOADER_WHEARHOUSE, cargando: true});
    api.eliminar(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_WHEARHOUSE, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1));
            })
    }).then((data) => {
        dispatch({type: LOADER_WHEARHOUSE, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(listar(1));
            })
    })
}

const search = (search) => (dispatch) => {
    dispatch({type: SET_BUSCADOR_WHEARHOUSE, buscador: search});
    dispatch(listar(1));
};

const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_WHEARHOUSE, filtro_whearhouse: filtro});
    dispatch(listar(1));
};

export const actions = {
    listar,
    create,
    update,
    detail,
    destroy,
    search,
    filtro,
};

export const reducer = {
    [LOADER_WHEARHOUSE]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_WHEARHOUSE]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_WHEARHOUSE]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_WHEARHOUSE]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_WHEARHOUSE]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_WHEARHOUSE]: (state, { filtro_whearhouse }) => {
        return {...state, filtro_whearhouse }
    },
};

export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_whearhouse: null,
    updateData: {},
};

export default handleActions(reducer, initialState)
